 import { calcNbrMonthsBtwnDates } from "../../../../objects/CommonUse/nbr_months_btwn_dates_calc";

 export const determineIfPartialCoupon = (couponFrequency, gameDate, buySellDate, tranType) => {
   
    //  note:  currently partial pay multiplier is only correct for semi-annual coupons/dividends!!!
    let partialPayMultiplier = 1;
    if (tranType === "buy"){
         // if buy bond on same month as coupon, then no coupon amount is paid
         // set this as the default value!
        partialPayMultiplier = 0;
    }
    let partialNbrMonths = 99;  // if partial months not calculated then do not calc partial pay multiplier
    const gameMonth = gameDate.split('-')[1];
    let calcMonth = "";
    if (tranType === "buy" || tranType === "sell"){
        if (+gameMonth < 6){
             calcMonth = 0;
        }else{
             calcMonth = 6;
        }
        partialNbrMonths = +gameMonth - calcMonth;
    }else{
        // tranType is "game" -- date will either be june or december
        if (gameDate !== buySellDate){
            partialNbrMonths = calcNbrMonthsBtwnDates(buySellDate, gameDate);
        }
    }
    // if partialMonths is greater than frequency then it is not a partial pay 
    if (partialNbrMonths < +couponFrequency){
        partialPayMultiplier = partialNbrMonths / +couponFrequency;
    };
    
    return partialPayMultiplier;
}

export default determineIfPartialCoupon;